module.exports = __webpack_public_path__ + "img/08f2740.jpg";